import React from 'react';
import CampaignListLayout from '../component-library/layout/campaignListLayout/CampaignListLayout';
import SectionBackground from '../component-library/SectionBackground';
import { PageSectionComponent } from './pageSections';
import RichText from './RichText/RichText';
import { ICampaignItem } from '../../types/@types/generated/contentful';
import Image, { ImageStyleProps } from './Image';

const CampaignsSection: PageSectionComponent<null> = ({
  section: {
    fields: { title, description, references, settings },
  },
}) => (
  <SectionBackground id={settings?.id} backgroundColor={settings?.backgroundColor}>
    <CampaignListLayout
      Title={({ color }) => <RichText document={title} textColor={color} />}
      Description={({ color }) => <RichText document={description} textColor={color} />}
      campaigns={(references as ICampaignItem[]).map(
        ({
          fields: {
            campaignName,
            campaignDescription,
            campaignLink,
            campaignImage,
            campaignPartnerLogo,
          },
        }) => ({
          name: campaignName,
          description: campaignDescription,
          link: campaignLink,
          // eslint-disable-next-line react/display-name
          Image: (props: ImageStyleProps) =>
            campaignImage ? <Image asset={campaignImage} {...props} /> : null,
          // eslint-disable-next-line react/display-name
          Logo: (props: ImageStyleProps) =>
            campaignPartnerLogo ? <Image asset={campaignPartnerLogo} {...props} /> : null,
        }),
      )}
    />
  </SectionBackground>
);

export default CampaignsSection;
